module.exports = __webpack_public_path__ + "img/3D_Face_Right.7070bc53.gif";